export default [
  {
    value: 1,
    label: "ผู้บริหาร",
  },
  {
    value: 2,
    label: "นักบัญชี",
  },
  {
    value: 3,
    label: "นักออกแบบ",
  },
  {
    value: 4,
    label: "นักเขียนคอนเทนต์",
  },
  {
    value: 5,
    label: "นักวิเคราะห์ธุรกิจ",
  },
  {
    value: 6,
    label: "นักวิเคราะห์ระบบ",
  },
  {
    value: 7,
    label: "นักเขียนโปรแกรม",
  },
  {
    value: 8,
    label: "นักทดสอบระบบ",
  },
  {
    value: 9,
    label: "ผู้จัดการโครงการ",
  },
  {
    value: 10,
    label: "ผู้จัดการโซเชียลมีเดีย",
  },
  {
    value: 11,
    label: "พนักงานขาย",
  },
  {
    value: 12,
    label: "พนักงานบัญชี",
  },
  {
    value: 13,
    label: "พนักงานบริษัท",
  },
  {
    value: 999,
    label: "อื่นๆ",
  },
];
